import { useEffect, useMemo } from "react";
import { signal, useSignal } from "@preact/signals-react";

import Board from "componentsv2/board/Board";
import { layoutParty } from "./Party";
import { useGlobal } from "storev2/globalStore";
import HelpDesk from "./HelpDesk";
import { message, message2 } from "./helpdeskInfo";
import proxy from "api/proxy";
import { getStorage } from "store/local";

const currentView = signal("list");
const reloadId = signal(0);
const alertMsg = signal({
  show: false,
  text: null,
  icon: "xmark",
  color: "bg-red-200",
  autoRemove: true,
});

function PartyScreen() {
  function showAlert(text) {
    alertMsg.value = {
      show: true,
      text,
      icon: "xmark",
      color: "bg-red-200",
      autoRemove: true,
    };
  }
  const layout = useMemo(() => {
    const layout_ = layoutParty(showAlert);
    layout_.alertMsg = alertMsg;
    return layout_;
  }, []);
  const loadData = useGlobal((state) => state.loadData);

  const commissionActive = useSignal(false);
  const hasAgentsField = useSignal(false);

  async function checkFields() {
    const { data } = await proxy.getFields(layout.model, []);
    hasAgentsField.value = !!data?.["agents"];
  }

  async function checkModules() {
    const { data } = await proxy.search(
      "ir.module",
      [
        ["name", "=", "commission"],
        ["state", "=", "activated"],
      ],
      ["name", "state"],
    );
    commissionActive.value = data?.length > 0;
  }

  useEffect(() => {
    if (!commissionActive.value || !hasAgentsField.value) {
      layout.softDomain = null;
      layout.reports = undefined;
      return;
    }
    let cancelled = false;
    (async () => {
      const session = getStorage("ctxSession");
      if (!session?.user) return;
      const { data } = await proxy.search(
        "commission.agent",
        [["user", "=", session.user]],
        ["id", "rec_name"],
        1,
      );
      if (cancelled) return;
      if (data?.[0]) {
        const { data: count } = await proxy.searchCount(
          "party.party",
          [["agents.agent.user", "=", session.user]],
        );
        if (cancelled) return;
        layout.softDomain = count > 0
          ? [["agents.agent.user", "=", session.user]]
          : null;
        layout.reports = count > 0
          ? [{ name: "invoice_report.party_dunning", label:"invoice_report.party_dunning", description:"invoice_report.party_dunning", send_print: true }]
          : undefined;
      } else {
        layout.softDomain = null;
        layout.reports = undefined;
      }
      reloadId.value += 1;
    })();
    return () => {
      cancelled = true;
    };
  }, [commissionActive.value, hasAgentsField.value]);

  useEffect(() => {
    async function setData() {
      await loadData();
    }
    setData();
    checkFields();
    checkModules();
  }, [loadData]);

  return (
    <div className="md:flex w-full">
      <Board layout={layout} style="md:w-2/3" currentView={currentView} reloadId={reloadId.value} />
      <HelpDesk message={message} message2={message2} />
    </div>
  );
}

export default PartyScreen;
